import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as LogoIcon } from "../../../../assets/shared/logo.svg";
import "./logo.scss";
function Logo(props) {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <Link
      to="/"
      className="nav-logo"
      onClick={() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }}
    >
      {props.logo}

      <h1 className={`${props.className}`}>YLLIRI</h1>
    </Link>
  );
}

export default Logo;
